import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import BurgerIcon from '../icons/Burger';

import styles from '../../../styles/buttons/burger.scss';

const propTypes = {
    onClick: PropTypes.func.isRequired,
    isActive: PropTypes.bool,
    color: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    isActive: false,
    color: null,
    className: null,
};

const Burger = ({ onClick, isActive, color, className }) => (
    <div className={classNames([styles.container, { [className]: className !== null }])}>
        <button
            className={classNames([styles.burger, { [styles.isActive]: isActive }])}
            type="button"
            onClick={onClick}
        >
            <BurgerIcon color={color} />
        </button>
    </div>
);

Burger.propTypes = propTypes;
Burger.defaultProps = defaultProps;

export default Burger;
